import React from 'react';
import { ContentRendererProps } from './types';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';

/**
 * Default fallback renderer for content types that don't have a specific implementation
 */
export const DefaultRenderer: React.FC<ContentRendererProps> = ({ content }) => {
  return (
    <div className="w-full h-full overflow-auto">
      <Alert className="mb-4">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>No Specific Renderer Available</AlertTitle>
        <AlertDescription>
          This content type does not have a specialized renderer. Displaying raw content.
        </AlertDescription>
      </Alert>
      
      <Card>
        <CardHeader>
          <CardTitle>{content.name}</CardTitle>
        </CardHeader>
        <CardContent>
          <pre className="text-sm whitespace-pre-wrap bg-muted p-4 rounded-md overflow-auto">
            {JSON.stringify(content.content_json, null, 2)}
          </pre>
        </CardContent>
      </Card>
    </div>
  );
};

export default DefaultRenderer; 